import { memo } from 'react';

import PersonBasicInfo from '@/components/PersonBasicInfo';
import PersonBasicInfoHeader from '@/components/PersonBasicInfoHeader';
import { Modal } from '@/ui';

import type { Props } from './types';

const PersonBasicInfoModal = ({ onClose, open, person }: Props) => (
  <Modal open={open} onClose={onClose} size="sm" title={<PersonBasicInfoHeader person={person} />}>
    <div className="-mx-6 border-t border-uniform-gray-200 px-6 pt-4 dark:border-uniform-gray-700">
      <PersonBasicInfo person={person} withHeader={false} />
    </div>
  </Modal>
);

export default memo(PersonBasicInfoModal);
